module.exports = __webpack_public_path__ + "img/21_17.4fd2ee2e.png";